import { expValEquals, UNSAFE_noExposureExp } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

/**
 * Whether the approval activity log is enabled for the current user/tenant.
 *
 * Checks are sequential (not chained with `&&`) to avoid preconditioning one
 * gate/experiment with another, which keeps Statsig exposures accurate.
 */
export const isApprovalActivityEnabled = (): boolean => {
	if (!fg('confluence_approvals_beta')) {
		return false;
	}

	if (!expValEquals('confluence_approvals_eap', 'isEnabled', true)) {
		return false;
	}

	// The dynamic config exposes its boolean under `value` (not `isEnabled`).
	const [activityLogConfig] = UNSAFE_noExposureExp('confluence_approvals_activity_log');
	return activityLogConfig.get('value', false) === true;
};
